import { Spiner } from '@/shared/ui/spiner'
import { useStyles } from './styles'

function AppLoading({ text }: { text?: string }) {
  const { classes } = useStyles()
  return (
    <div className={classes.root}>
      <Spiner variant="secondary" />
      {text ? <p>{text}</p> : ''}
    </div>
  )
}

export default AppLoading
